<!-- 生徒，教師名をテキスト入力しながらプルダウンを選ぶ -->
<template lang="html">
  <div class="autocomplete">
    <input class="form-control" type="text" :value="input" :placeholder="'入力して検索'"
    @click.prevent="click"
    @input.prevent="updateValue($event.target.value)"
    @keydown.enter.prevent = 'enter'
    @keydown.down.prevent = "down"
    @keydown.up.prevent = "up"
    >
    <ul class="dropdown-menu" style="width:100%; height: 300px; overflow-y: scroll"  v-show="openSuggestion">
      <li v-for="(suggestion, index) in matches"
      :class="{'active': isActive(index)}"
      @click="suggestionClick(index)">
        <span>{{ suggestionDisplay(suggestion) }}</span>
    </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: [
    'suggestions',
    'type',
    'value',
    'placeholder'
  ],
  data () {
    return {
      input: '',
      open: false,
      current: 0
    }
  },
  computed: {
    // サジェストのフィルタリング
    matches () {
      return this.suggestions.sort((a, b) => {
        return (a.kana > b.kana) ? 1 : (a.kana < b.kana ? -1 : -1)
      }).filter((obj) => {
        return obj.fullname.indexOf(this.input) >= 0
      })
    },
    openSuggestion () {
      return this.matches.length !== 0 &&
              this.open === true
    }
  },
  methods: {
    updateValue (value) {
      if (this.open === false) {
        this.open = true
        this.current = 0
      }
      this.input = value
    },
    enter () {
      let id = ''
      const matchObj = this.matches[this.current]
      let name = ''
      id = matchObj.id
      if (!id === undefined) {
        id = matchObj.user_id
      }
      name = matchObj.fullname
      this.$emit('input', id)
      this.input = name
      this.open = false
    },
    up () {
      if (this.current > 0) {
        this.current--
      }
    },
    click () {
      this.open = !this.open
      this.input = ''
      this.$emit('input', 0)
    },
    down () {
      if (this.current < this.matches.length - 1) {
        this.current++
      }
    },
    isActive (index) {
      return index === this.current
    },
    suggestionClick (index) {
      let id = ''
      const matchObj = this.matches[index]
      let name = ''
      id = matchObj.id
      if (!id) {
        id = matchObj.user_id
      }
      name = matchObj.fullname
      this.$emit('input', id)
      this.input = name
      this.open = false
    },
    suggestionDisplay (suggestion) {
      return suggestion.fullname
    },
    exactFullname () {
      if (this.value === 0) {
        return ''
      }
      let theuser = this.suggestions.find((elem, array, self) => {
        return elem.id === this.value
      })
      return theuser.fullname
    }
  },
  mounted () {
    this.input = this.exactFullname()
  }
}
</script>

<style lang="css" scoped>
.autocomplete {
  display: inline;
}
.dropdown-menu {
  border-style: solid;
  border-width:  1px;
}
ul>li {
  color: gray;
  position: relative;
}
ul>li:hover {
  color: black;
}
.active {
  color: white;
  background-color: #0065B3;
}
</style>



// WEBPACK FOOTER //
// SpAutocompleteSelection.vue?953b16c8